module.exports = __webpack_public_path__ + "img/cc71f4f46693998aad5db0a53cc8da7.caf48a0d.png";